import axios from 'axios';
import React, { Component } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert/lib/dist/SweetAlert';
import MaskedInput from 'react-text-mask';
import { Input } from 'reactstrap';
import PropTypes from 'prop-types';
import imgfLoading from '../../assets/img/preloader-black.gif';
import { Alert } from '../../components/Alert';
import Axios from '../../config/Axios';
import { validateCNPJ, validateCPF } from '../../config/Validator';
import PageClean from '../default/PageClean';
import { getPartnerOptions } from '../../actions/ActionPartnerWL';
import aCountries from './countries.json';
import Select, { createFilter } from 'react-select';
import { createCustomer, getCustomerTemplateOptions } from '../../actions/ActionCustomer';
import { tCustomerTemplate } from '../../i18n/customerTemplateImport';

const oShow = {
  display: 'block'
};

const oHide = {
  display: 'none'
};

const oBrazilStates = {
  "Acre": "AC",
  "Alagoas": "AL",
  "Amazonas": "AM",
  "Amapá": "AP",
  "Bahia": "BA",
  "Ceará": "CE",
  "Distrito Federal": "DF",
  "Espirito Santo": "ES",
  "Goiás": "GO",
  "Maranhão": "MA",
  "Minas Gerais": "MG",
  "Mato Grosso do Sul": "MS",
  "Mato Grosso": "MT",
  "Pará": "PA",
  "Paraíba": "PB",
  "Pernambuco": "PE",
  "Piauí": "PI",
  "Paraná": "PR",
  "Rio de Janeiro": "RJ",
  "Rio Grande do Norte": "RN",
  "Rondônia": "RO",
  "Rorâima": "RR",
  "Rio Grande do Sul": "RS",
  "Santa Catarina": "SC",
  "Sergipe": "SE",
  "São Paulo": "SP",
  "Tocantins": "TO"
};

export const aCountryOptions = aCountries.map(oCountry => ({
  label: oCountry.name,
  value: oCountry.name
}));

export const aStateOptions = Object.values(oBrazilStates).map((cUF) => ({
  label: cUF,
  value: cUF
}));

export const getBrazilCities = async (cStateUF) => {
  if (!cStateUF) return [];
  try {
    const oResponse = await axios.get(`${process.env.REACT_APP_CEP_BASE_URL}cities/${cStateUF}/json`);
    if (!oResponse.data) return [];
    return oResponse.data.map(oCity => ({
      label: oCity.nome,
      value: oCity.nome,
      ibge: oCity.ibge
    }));
  } catch (oError) {
    return [];
  }
};

const isBrazil = (cCountry) => /^Bra[sz]il$/i.test(cCountry);

export const getPostalCodeAddress = async (cPostalCode, cPrefix = 'cust_') => {
  const oResult = {};
  const cCleanPostalCode = cPostalCode.replace('-', '');

  if (!cPostalCode) return oResult;

  const oResponse = await axios.get(`${process.env.REACT_APP_CEP_BASE_URL}cep/${cCleanPostalCode}/json`);
  /* eslint-disable default-case */
  Object.entries(oResponse.data.result).forEach(([cKey, cValue]) => {
    switch (cKey) {
      case 'logradouro':
        return oResult[cPrefix + 'cstreet'] = cValue;
      case 'localidade':
        return oResult[cPrefix + 'ccity'] = cValue;
      case 'estado':
        return oResult[cPrefix + 'cstate'] = oBrazilStates[cValue];
      case 'bairro':
        return oResult[cPrefix + 'cdistrict'] = cValue;
      case 'cibgelocalidade':
        return oResult[cPrefix + 'cibgecode'] = cValue;
    }
  });
  /* eslint-enable default-case */
  oResult[cPrefix + 'ccountry'] = 'Brasil';

  return oResult;
};

class Customer extends Component {

  static propTypes = {
    bIsEditing: PropTypes.bool,
    bIsModal: PropTypes.bool,
    fnHandleClose: PropTypes.func,
    fnHandleConfirm: PropTypes.func,
  };

  static defaultProps = {
    bIsEditing: false,
    bIsModal: false,
    fnHandleClose: evtHandleClose => { },
    fnHandleConfirm: evtHandleConfirm => { },
  };

  constructor(oProps) {
    super(oProps);

    this.bPostalCodeValidated = React.createRef();

    this.state = {
      oUser: [],
      oCustomer: {
        cust_ctype: 'PF',
        cust_clanguage: "pt-br",
        wlpn_nid: null,
      },
      bLoading: true,
      rcmpAlertMsg: null,
      aCityOptions: [],
      aPartners: [],
      aCustomerTemplates: [],
      template_id: null,
    };
  }


  componentDidMount() {
    const { bIsEditing, nCustId } = this.props;
    if (bIsEditing) {
      Axios.get(`customer/${nCustId}`)
        .then(oResponse => {
          this.setState({
            oCustomer: oResponse.data.oCustomer,
            bLoading: false
          });
          this.updateCityOptions();
        })
        .catch(oError => {
          this.setState({
            rcmpAlertMsg: (
              <Alert type="error" isOpen onCloseAlert={() => { }}>
                {oError.aMsgErrors}
              </Alert>
            )
          });
        })
    } else {
      Promise.all([
        getPartnerOptions(),
        getCustomerTemplateOptions().catch(() => []),
      ]).then(([aPartners, aCustomerTemplates]) => {
        const oOptionNone = aPartners.find(p => p.value === -1);
        if (oOptionNone) {
          // "Acredite-se" vem como -1
          oOptionNone.value = null;
        }
        this.setState({ aPartners, aCustomerTemplates, bLoading: false });
      });
    }
  }

  updateCityOptions = async () => {
    const { oCustomer } = this.state;
    const cUF = oCustomer.cust_cstate;

    const aCityOptions = isBrazil(oCustomer.cust_ccountry) && cUF
      ? await getBrazilCities(cUF)
      : [];
    this.setState({ aCityOptions });
  }

  verifyPostalCode = async (evt) => {
    if (this.bPostalCodeValidated.current) return;

    const { oCustomer } = this.state;
    const cPostalCode = document.getElementById('cust_cpostalcode').value.replace('-', '');

    const oResult = await getPostalCodeAddress(cPostalCode);
    this.setState({ oCustomer: Object.assign(oCustomer, oResult) });
    this.bPostalCodeValidated.current = true;
    await this.updateCityOptions(oResult.cust_cstate);
  };

  showPassword = () => {
    const elInputUserPassword = document.getElementById('user_cpassword');
    if (elInputUserPassword.type === 'password') {
      elInputUserPassword.type = 'text';
      elInputUserPassword.parentNode.children[1].classList.add('alt');
    } else {
      elInputUserPassword.type = 'password';
      elInputUserPassword.parentNode.children[1].classList.remove('alt');
    }
  };

  inputChangeHandler = async (evt) => {
    const { oCustomer, aCityOptions } = this.state;
    const cField = evt.target.name;
    const cValue = evt.target.value;
    if (cValue == null) return;

    oCustomer[cField] = cValue;

    let bUpdatedState = false;
    /* eslint-disable default-case, no-fallthrough */
    switch (cField) {
      case 'cust_ccountry':
        oCustomer.cust_cstate = '';
      case 'cust_cstate':
        oCustomer.cust_ccity = '';
        bUpdatedState = true;
      case 'cust_ccity':
        const { ibge } = aCityOptions.find(oCity => oCity.value === oCustomer.cust_ccity) || { ibge: null };
        oCustomer.cust_cibgecode = ibge;
    }
    /* eslint-enable default-case, no-fallthrough */
    this.setState({ oCustomer });

    if (bUpdatedState) {
      await this.updateCityOptions();
    }
  };

  inputChangeHandlerUser = (evt) => {
    let { oUser } = this.state;
    oUser = { ...oUser };
    if (evt.target.value != null) {
      oUser[evt.target.name] = evt.target.value;
      this.setState({
        oUser
      });
    }
  };

  handleSubmit = (evt) => {
    evt.preventDefault();

    const { oCustomer, oUser, template_id } = this.state;
    const { history, bIsEditing, fnHandleConfirm } = this.props;

    if (bIsEditing) {
      Axios.put(`customer/${oCustomer.cust_nid}`, {
        oCustomer
      })
        .then((oResponse) => {
          fnHandleConfirm('success', oResponse.data.success);
        })
        .catch((oError) => {
          this.setState({
            rcmpAlertMsg: (
              <Alert type="error" isOpen onCloseAlert={() => { }}>
                {oError.aMsgErrors}
              </Alert>
            )
          });
        });
    } else {
      this.setState({
        rcmpAlertMsg: (
          <SweetAlert disabled showConfirm={false} title="Cadastrando cliente..." onConfirm={() => { }}>
            <img alt="Carregando" src={imgfLoading} />
          </SweetAlert>
        )
      });

      oUser['user_cname'] = oCustomer.cust_cname;
      oCustomer.oUser = oUser;

      createCustomer({ oCustomer, oUser, template_id })
        .then(() => {
          this.setState({
            rcmpAlertMsg: (
              <SweetAlert
                success
                title="Cadastrado!"
                onConfirm={() => {
                  this.hideAlert();
                  history.push('/Customer');
                }}
              >
                Cliente cadastrado com sucesso.
              </SweetAlert>
            )
          });
        })
        .catch((oError) => {
          this.setState({
            rcmpAlertMsg: (
              <Alert type="error" isOpen onCloseAlert={() => { }}>
                {oError.aMsgErrors}
              </Alert>
            )
          });
        });
    }
  };

  validateCustomerCNPJ = (evt) => {
    if (!validateCNPJ(evt.target.value)) {
      const { oCustomer } = this.state;
      oCustomer.cCnpj = '';
      this.setState({
        oCustomer,
        rcmpAlertMsg: (
          <SweetAlert
            danger
            confirmBtnText="Ok"
            confirmBtnBsStyle="danger"
            title="CNPJ inválido"
            onConfirm={this.hideAlert}
            onCancel={this.hideAlert}
          />
        )
      });
    }
  };

  validateCustomerCPF = (evt) => {
    if (!validateCPF(evt.target.value)) {
      const { oCustomer } = this.state;
      oCustomer.cust_ccpf = '';
      this.setState({
        oCustomer,
        rcmpAlertMsg: (
          <SweetAlert
            danger
            confirmBtnText="Ok"
            confirmBtnBsStyle="danger"
            title="CPF inválido"
            onConfirm={this.hideAlert}
            onCancel={this.hideAlert}
          />
        )
      });
    }
  };

  hideAlert = () => {
    this.setState({
      rcmpAlertMsg: null
    });
  };

  renderForm = () => {
    const { oCustomer, oUser, aPartners, aCityOptions, aCustomerTemplates, template_id } = this.state;
    const { bIsEditing, fnHandleClose, history } = this.props;

    const bIsBrazilAddress = isBrazil(oCustomer.cust_ccountry);

    return (
      <>
        <form autoComplete="false" onSubmit={this.handleSubmit} className="form">
          <fieldset>
            <legend>Informações cadastrais</legend>
            <label className="split">
              Tipo de cadastro <span className="required">*</span>
              <Input
                type="select"
                name="cust_ctype"
                id="cust_ctype"
                onChange={this.inputChangeHandler}
                value={oCustomer.cust_ctype || 'PF'}
                required
              >
                <option value="PF">Pessoa Física</option>
                <option value="PJ">Pessoa Jurídica</option>
              </Input>
            </label>

            <label className="split2">
              {oCustomer.cust_ctype === 'PJ' ? 'Razão Social' : 'Nome Completo'} <span className="required">*</span>
              <Input
                type="text"
                name="cust_cname"
                id="cust_cname"
                maxLength="250"
                required
                onChange={this.inputChangeHandler}
                value={oCustomer.cust_cname || ''}
              />
            </label>

            <label style={oCustomer.cust_ctype === 'PF' ? oShow : oHide} className="split2">
              CPF <span className="required">*</span>
              <MaskedInput
                onBlur={this.validateCustomerCPF}
                // disabled={this.state.cliente.ccpf ? true : false}
                mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                onChange={this.inputChangeHandler}
                render={(cRef, oProps) => (
                  <Input
                    innerRef={cRef}
                    {...oProps}
                    value={oCustomer.cust_ccpf || ''}
                    type="text"
                    name="cust_ccpf"
                    id="cust_ccpf"
                    className="mask-cpf"
                    placeholder="CPF"
                    required={oCustomer.cust_ctype === 'PF'}
                  />
                )}
              />
            </label>

            <label style={oCustomer.cust_ctype === 'PJ' ? oShow : oHide} className="split2">
              CNPJ <span className="required">*</span>
              <MaskedInput
                onBlur={this.validateCustomerCNPJ}
                // disabled={this.state.cliente.ccnpj ? true : false}
                mask={[
                  /\d/,
                  /\d/,
                  '.',
                  /\d/,
                  /\d/,
                  /\d/,
                  '.',
                  /\d/,
                  /\d/,
                  /\d/,
                  '/',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  '-',
                  /\d/,
                  /\d/
                ]}
                onChange={this.inputChangeHandler}
                render={(cRef, oProps) => (
                  <Input
                    innerRef={cRef}
                    {...oProps}
                    value={oCustomer.cust_ccnpj || ''}
                    type="text"
                    name="cust_ccnpj"
                    id="cust_ccnpj"
                    placeholder="CNPJ"
                    required={oCustomer.cust_ctype === 'PJ'}
                  />
                )}
              />
            </label>

            <label style={oCustomer.cust_ctype === 'PJ' ? oShow : oHide} className="split2">
              <span>Nome fantasia</span>
              <Input
                onChange={this.inputChangeHandler}
                value={oCustomer.cust_cfantasyname || ''}
                type="text"
                name="cust_cfantasyname"
                id="cust_cfantasyname"
                placeholder="Nome fantasia"
              />
            </label>

            <label className="split2">
              Telefone
              <MaskedInput
                mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/]}
                onChange={this.inputChangeHandler}
                render={(cRef, oProps) => (
                  <Input
                    innerRef={cRef}
                    {...oProps}
                    value={oCustomer.cust_cphone || ''}
                    type="text"
                    name="cust_cphone"
                    id="cust_cphone"
                    className="mask-phone"
                    placeholder="Telefone"
                  />
                )}
              />
            </label>

            <label className="split2">
              Celular <span className="required">*</span>
              <MaskedInput
                mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/]}
                onChange={this.inputChangeHandler}
                render={(cRef, oProps) => (
                  <Input
                    innerRef={cRef}
                    {...oProps}
                    value={oCustomer.cust_ccellphone || ''}
                    type="text"
                    name="cust_ccellphone"
                    id="cust_ccellphone"
                    className="mask-phone"
                    placeholder="Celular"
                    required
                  />
                )}
              />
            </label>

            <label className="split2">
              Idioma padrão <span className="required">*</span>
              <Input
                type="select"
                id="cust_clanguage"
                name="cust_clanguage"
                onChange={this.inputChangeHandler} value={oCustomer.cust_clanguage || ''}
                required
              >
                <option value="pt-br">Português</option>
                <option value="en">English</option>
              </Input>
            </label>
          </fieldset>

          {!bIsEditing && (
            <fieldset>
              <legend>Usuário</legend>

              <label className="split2">
                E-mail <span className="required">*</span>
                <Input
                  onChange={this.inputChangeHandlerUser}
                  value={oUser.user_cemail || ''}
                  type="email"
                  name="user_cemail"
                  id="user_cemail"
                  placeholder="E-mail"
                  autoComplete="new-email"
                  required
                />
              </label>
              <label className="split2 password">
                Senha <span className="required">*</span>
                <Input
                  onChange={this.inputChangeHandlerUser}
                  value={oUser.user_cpassword || ''}
                  type="password"
                  name="user_cpassword"
                  id="user_cpassword"
                  placeholder="Senha"
                  autoComplete="new-password"
                  required
                />
                <span onClick={this.showPassword} title="Mostrar/esconder senha" className="btn-hover" />
              </label>
            </fieldset>
          )}

          <fieldset>
            <legend>Endereço</legend>

            <label className="split2 search">
              CEP <span className="required">*</span>
              <MaskedInput
                mask={[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
                onChange={(evt) => {
                  this.bPostalCodeValidated.current = false;
                  this.inputChangeHandler(evt);
                }}
              onBlur={this.verifyPostalCode}
                render={(cRef, oProps) => (
                  <Input
                    innerRef={cRef}
                    {...oProps}
                    value={oCustomer.cust_cpostalcode || ''}
                    type="text"
                    className="mask-cep cep-fill"
                    name="cust_cpostalcode"
                    id="cust_cpostalcode"
                    placeholder="CEP"
                    required
                  />
                )}
              />
              <span onClick={this.verifyPostalCode} title="Buscar Cep" className="btn-hover" />
            </label>

            <label className="split2">
              Endereço <span className="required">*</span>
              <Input
                onChange={this.inputChangeHandler}
                value={oCustomer.cust_cstreet || ''}
                type="text"
                name="cust_cstreet"
                id="cust_cstreet"
                placeholder="Endereço"
                required
              />
            </label>

            <label className="split2">
              Número <span className="required">*</span>
              <Input
                onChange={this.inputChangeHandler}
                value={oCustomer.cust_cnumber || ''}
                type="text"
                name="cust_cnumber"
                id="cust_cnumber"
                placeholder="Número"
                required
              />
            </label>

            <label className="split2">
              Complemento
              <Input
                onChange={this.inputChangeHandler}
                value={oCustomer.cust_ccomplement || ''}
                type="text"
                name="cust_ccomplement"
                id="cust_ccomplement"
              />
            </label>

            <label className="split2">
              Bairro <span className="required">*</span>
              <Input
                onChange={this.inputChangeHandler}
                value={oCustomer.cust_cdistrict || ''}
                type="text"
                name="cust_cdistrict"
                id="cust_cdistrict"
                placeholder="Bairro"
                required
              />
            </label>

            <label className="split2">
              Cidade <span className="required">*</span>
              {bIsBrazilAddress ? (
                <Select
                  className="selectCustom"
                  classNamePrefix="react-select"
                  filterOption={createFilter({ matchFrom: 'start' })}
                  options={aCityOptions}
                  onChange={oOption => this.inputChangeHandler({ target:
                    { name: 'cust_ccity', value: oOption.value }
                  })}
                  value={{ label: oCustomer.cust_ccity || '', value: oCustomer.cust_ccity || '' }}
                  placeholder="Cidade"
                  required
                />
              ) : (
                <Input
                  onChange={this.inputChangeHandler}
                  value={oCustomer.cust_ccity || ''}
                  type="text"
                  name="cust_ccity"
                  id="cust_ccity"
                  placeholder="Cidade"
                  autocomplete="off"
                  required
                />
              )}

            </label>

            <label className="split2">
              Estado <span className="required">*</span>
              {bIsBrazilAddress ? (
                <Select
                  className="selectCustom"
                  classNamePrefix="react-select"
                  options={aStateOptions}
                  onChange={oOption => this.inputChangeHandler({ target:
                    { name: 'cust_cstate', value: oOption.value }
                  })}
                  value={{ label: oCustomer.cust_cstate || '', value: oCustomer.cust_cstate || '' }}
                  placeholder="UF"
                  required
                />
              ) : (
                <Input
                  onChange={this.inputChangeHandler}
                  value={oCustomer.cust_cstate || ''}
                  type="text"
                  name="cust_cstate"
                  id="cust_cstate"
                  placeholder="Estado"
                  autocomplete="off"
                  required
                />
              )}
            </label>

            <label className="split2">
              País <span className="required">*</span>
              <Select
                className="selectCustom"
                classNamePrefix="react-select"
                options={aCountryOptions}
                onChange={oOption => this.inputChangeHandler({
                  target: { name: 'cust_ccountry', value: oOption.value }
                })}
                value={{ label: oCustomer.cust_ccountry || '', value: oCustomer.cust_ccountry || '' }}
                placeholder="País"
                required
              />
            </label>
          </fieldset>

          <fieldset>
            <legend>Configurações admin</legend>

            <label className={!bIsEditing ? "split2" : ""}>
              Tipo
              <Input
                type="select"
                name="cust_ctypeuser"
                id="cust_ctypeuser"
                onChange={this.inputChangeHandler}
                value={oCustomer.cust_ctypeuser || 'Cliente'}
                required>
                <option value="Cliente">Cliente</option>
                <option value="Consultoria">Consultoria</option>
                <option value="Certificadora">Certificadora</option>
              </Input>
            </label>

            {!bIsEditing && (
              <label className="split2">
                Parceiro White Label
                <Input
                  type="select"
                  name="wlpn_nid"
                  id="wlpn_nid"
                  onChange={this.inputChangeHandler}
                  value={oCustomer.wlpn_nid || ''}
                >
                  {aPartners.map((oPartner) => (
                    <option key={oPartner.label} value={oPartner.value}>{oPartner.label}</option>
                  ))}
                </Input>
              </label>
            )}

            {!bIsEditing && (
              <label className="split2">
                {tCustomerTemplate('customerTemplate.baseModel')}
                <Input
                  type="select"
                  name="template_id"
                  id="template_id"
                  onChange={(evtChange) => this.setState({
                    template_id: evtChange.target.value ? Number(evtChange.target.value) : null
                  })}
                  value={template_id || ''}
                >
                  <option value="">{tCustomerTemplate('customerTemplate.noModel')}</option>
                  {aCustomerTemplates.map((oTemplate) => (
                    <option key={oTemplate.value} value={oTemplate.value}>{oTemplate.label}</option>
                  ))}
                </Input>
              </label>
            )}
          </fieldset>

          <div className="button-stack">
            <button type="button" className="btn alternate back btn btn-outline-secondary" title="Cancelar" onClick={(evtClick) => {
            if (bIsEditing) {
              fnHandleClose();
            } else {
              history.push({
                pathname: '/Customer'
              });
            }
          }}>
              Cancelar
            </button>
            {bIsEditing ?
              (
                <button type="submit" value="salvar" className="btn btn btn-secondary" title="Salvar">
                  Salvar
                </button>
              ): (
                <button type="submit" value="salvar" className="btn btn btn-secondary" title="Criar">
                  Criar
                </button>
              )
            }
          </div>
        </form>

      </>
    );
  }

  render() {
    const { rcmpAlertMsg, bLoading  } = this.state;
    const { bIsEditing, bIsModal } = this.props;

    if (bIsModal) {
      return (
        <PageClean bLoading={bLoading ? 1 : 0}>
          {rcmpAlertMsg}
          {this.renderForm()}
        </PageClean>
      );
    }

    return (
      <div className="centered">
        {rcmpAlertMsg}
        {!bIsEditing && (
          <div className="title-button">
            <h1>Cadastrar cliente</h1>
          </div>
        )}
        {this.renderForm()}
      </div>
    );
  }
}

export default Customer;
